import React from "react";
import NotificationsIcon from "@material-ui/icons/Notifications";
import CloseIcon from "@material-ui/icons/Close";
import { useDispatch, useSelector } from "react-redux";
import { dismissB2BNoticeBanner } from "../../../store/actions/b2b";

const NoticeBannerB2B = ({ isB2B, distributor }) => {
  const dispatch = useDispatch();
  const settings = useSelector((state) => state.store.store.settings);
  const language = useSelector((state) => state.store.language);
  const isNotificationDismissedB2B = useSelector(
    (state) => state.b2b.isNotificationDismissedB2B
  );
  const distributorOverride =
    distributor.override_banner && distributor.enable_banner;
  if (
    !isB2B ||
    isNotificationDismissedB2B ||
    !(distributor.override_banner
      ? distributor.enable_banner
      : settings.enable_banner_b2b)
  ) {
    return null;
  }
  return (
    <div
      className="bannerLargeScreen"
      style={{
        minHeight: 50,
        backgroundColor: distributorOverride
          ? distributor.banner_color
          : settings.banner_color_b2b,
        position: "fixed",
        top: 0,
        zIndex: 402,
        left: language === "english" && 0,
        right: language === "arabic" && 0,
        width: "100%",
        direction: language === "english" ? "ltr" : "rtl",
      }}
    >
      <div className="row w-100 m-auto">
        <div className="col-2" style={{ lineHeight: "50px", padding: 0 }}>
          <NotificationsIcon style={{ color: "white", fontSize: 25 }} />
        </div>
        <div
          className="col-8 cut-text-two-lines-banner"
          style={{
            color: "white",
            fontSize: 13,
            maxHeight: 50,
            margin: "auto",
            padding: 0,
          }}
        >
          {distributorOverride
            ? language === "english"
              ? distributor.banner_english
              : distributor.banner_arabic
            : language === "english"
            ? settings.banner_english_b2b
            : settings.banner_arabic_b2b}
        </div>

        <div
          className="col-2"
          style={{ lineHeight: "50px", padding: 0 }}
          onClick={() => dispatch(dismissB2BNoticeBanner())}
        >
          <CloseIcon style={{ color: "white", fontSize: 25 }} />
        </div>
      </div>
    </div>
  );
};

export default NoticeBannerB2B;
